/**
 * １次２次紐付け
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
import * as types from '../../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/linkages/registrations`

const manifest_linkage_registration = {
  namespaced: true,
  actions: {
    create ({ commit, state }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          const content = data.content
          commit('freelySnackbar/showInfo', {
            title: '登録しました',
            subTitle: 'DXEマニ番号',
            messages: [content.manifest_id],
            enableCopy: true,
            timeout: 6000,
          }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default manifest_linkage_registration
